module.exports = new __parcel__URL__("posterama.6c2e2313.png").toString();